import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "question-title-wrapper mb-14" }
const _hoisted_2 = { class: "question-title-index" }
const _hoisted_3 = {
  key: 0,
  class: "required-required"
}
const _hoisted_4 = {
  key: 1,
  class: "not-modified"
}
const _hoisted_5 = { class: "mt-20" }
const _hoisted_6 = { class: "fake-input-label d-flex justify-content-between" }
const _hoisted_7 = { class: "fake-input" }
const _hoisted_8 = { class: "mt-20" }
const _hoisted_9 = { class: "fake-input-label d-flex justify-content-between" }
const _hoisted_10 = { class: "fake-input new-value-input" }
const _hoisted_11 = {
  key: 2,
  class: "question-error"
}
const _hoisted_12 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_13 = { class: "flex items-center gap-2 pt-2 border-border" }
const _hoisted_14 = {
  key: 4,
  class: ""
}
const _hoisted_15 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_16 = {
  key: 1,
  class: "mb-10"
}
const _hoisted_17 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = {
  key: 3,
  class: "mb-10"
}
const _hoisted_20 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_21 = {
  key: 4,
  class: "mb-10"
}
const _hoisted_22 = { class: "d-flex justify-content-between" }
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = {
  key: 5,
  class: "top-gray-line"
}
const _hoisted_25 = { class: "input-box" }
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_title = _resolveComponent("question-title")!
  const _component_CalendarSvg = _resolveComponent("CalendarSvg")!
  const _component_question_option_input = _resolveComponent("question-option-input")!
  const _component_question_date_input = _resolveComponent("question-date-input")!
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_SearchMultipleSelect = _resolveComponent("SearchMultipleSelect")!
  const _component_select_input = _resolveComponent("select-input")!
  const _component_search_drop_down = _resolveComponent("search-drop-down")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_new_confirm_modal = _resolveComponent("new-confirm-modal")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.question.is_answer_changed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({
        'question-wrapper rounded-xl border border-border bg-muted/50 p-4 sm:p-5 shadow-sm': true,
        'is-rejecting': _ctx.questionAcceptRejectEdit.state === 'reject',
      })
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.count) + ".", 1),
              _createVNode(_component_question_title, {
                value: _ctx.question.text,
                "is-active": false
              }, null, 8, ["value"])
            ]),
            (_ctx.question.is_required)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "*"))
              : _createCommentVNode("", true),
            (!_ctx.question.is_answer_changed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Not Modified"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "base-label" }, "Original Answer", -1)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_CalendarSvg),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.question.answer_history[1].created_at)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.renderAnswerValue(_ctx.question.answer_history[1], _ctx.question) || 'Undefined') + "  ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "base-label" }, "New Answer", -1)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_CalendarSvg),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.question.answer_history[0].created_at)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.renderAnswerValue(_ctx.question.answer_history[0], _ctx.question)), 1)
              ])
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            (_ctx.questionAcceptRejectEdit.state === null || _ctx.questionAcceptRejectEdit.state === 'accept')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "how-does-this-look" }, " Hey does this look good? ", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "review-btn review-btn-reject inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors h-8 px-3 !text-xs",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.questionAcceptRejectEdit.state = 'reject'))
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        class: "h-3.5 w-3.5",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", { d: "M18 6 6 18" }),
                        _createElementVNode("path", { d: "m6 6 12 12" })
                      ], -1),
                      _createTextVNode(" Reject ", -1)
                    ]))]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "review-btn review-btn-edit inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors h-8 px-3 !text-xs",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.questionAcceptRejectEdit.state = 'edit'))
                    }, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        class: "h-3.5 w-3.5",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", { d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" }),
                        _createElementVNode("path", { d: "m15 5 4 4" })
                      ], -1),
                      _createTextVNode(" Edit ", -1)
                    ]))]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "review-btn review-btn-accept inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors h-8 px-3 !text-xs",
                      onClick: _cache[2] || (_cache[2] = () => {
              _ctx.questionAcceptRejectEdit.state = 'accept';
              _ctx.questionAcceptRejectEdit.isPopConfirmOpened = true;
            })
                    }, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        class: "h-3.5 w-3.5",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", { d: "M20 6 9 17l-5-5" })
                      ], -1),
                      _createTextVNode(" Accept ", -1)
                    ]))])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.questionAcceptRejectEdit.state === 'edit')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "fake-input-label" }, [
                    _createElementVNode("div", { class: "base-label" }, "Edit Value")
                  ], -1)),
                  (_ctx.question.type === 'text')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_question_option_input, {
                          placeholder: "Type your response",
                          value: _ctx.question.user_answer,
                          onOnValueChange: _ctx.handleValueUpdate
                        }, null, 8, ["value", "onOnValueChange"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'date')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_question_date_input, {
                          placeholder: "Date",
                          value: typeof _ctx.question.user_answer === 'string' ? _ctx.question.user_answer : '',
                          onOnValueChange: _ctx.handleValueUpdate
                        }, null, 8, ["value", "onOnValueChange"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'yes_no')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answer_values, (k, v) => {
                            return (_openBlock(), _createBlock(_component_radio_button, {
                              key: k,
                              class: "mr-10",
                              label: k,
                              value: v,
                              "is-active": _ctx.isResponseSelected(v),
                              onHandleValueChange: _ctx.handleYesNoChange
                            }, null, 8, ["label", "value", "is-active", "onHandleValueChange"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'multiple')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (Object.keys(_ctx.question.answer_values).length < 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answer_values, (k, v) => {
                                return (_openBlock(), _createBlock(_component_radio_button, {
                                  key: k,
                                  class: "mr-10 mb-6",
                                  label: k,
                                  value: v,
                                  "is-active": _ctx.isResponseSelected(v),
                                  onHandleValueChange: _ctx.handleMultipleChange
                                }, null, 8, ["label", "value", "is-active", "onHandleValueChange"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock(_component_SearchMultipleSelect, {
                              key: 1,
                              question: _ctx.question,
                              onOnUpdate: _ctx.handleValueUpdate
                            }, null, 8, ["question", "onOnUpdate"]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'drop_down')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (Object.keys(_ctx.question.answer_values).length < 20)
                          ? (_openBlock(), _createBlock(_component_select_input, {
                              key: 0,
                              class: "mb-10",
                              value: _ctx.question.user_answer && _ctx.question.user_answer !== null ? _ctx.question.user_answer[0] : null,
                              options: _ctx.getSelectInputOptions(_ctx.question.answer_values),
                              onHandleChange: _ctx.handleSelectChange
                            }, null, 8, ["value", "options", "onHandleChange"]))
                          : (_openBlock(), _createBlock(_component_search_drop_down, {
                              key: 1,
                              options: _ctx.getSearchSelectInputOptions(_ctx.question.answer_values),
                              onSelected: _ctx.handleSearchSelectChange,
                              defaultValue: _ctx.question.user_answer  && _ctx.question.user_answer !== null ? {id: _ctx.question.user_answer[0], name: _ctx.question.answer_values[_ctx.question.user_answer[0]]} : null
                            }, null, 8, ["options", "onSelected", "defaultValue"]))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_base_button, {
                      variant: "outlined",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.questionAcceptRejectEdit.state = null))
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode("Cancel", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_base_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = true))
                      }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("Save Edit", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.questionAcceptRejectEdit.state === 'reject')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "rejecting-info" }, [
                    _createElementVNode("svg", {
                      width: "20",
                      height: "20",
                      viewBox: "0 0 20 20",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M16.875 6.25L16.3542 15.11C16.3261 15.5875 16.1166 16.0363 15.7685 16.3644C15.4204 16.6925 14.96 16.8752 14.4817 16.875H5.51833C5.03997 16.8752 4.57962 16.6925 4.23152 16.3644C3.88342 16.0363 3.6739 15.5875 3.64583 15.11L3.125 6.25M8.125 9.6875L10 11.5625M10 11.5625L11.875 13.4375M10 11.5625L11.875 9.6875M10 11.5625L8.125 13.4375M2.8125 6.25H17.1875C17.705 6.25 18.125 5.83 18.125 5.3125V4.0625C18.125 3.545 17.705 3.125 17.1875 3.125H2.8125C2.295 3.125 1.875 3.545 1.875 4.0625V5.3125C1.875 5.83 2.295 6.25 2.8125 6.25Z",
                        stroke: "#6B6B6B",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ]),
                    _createElementVNode("span", null, "You are rejecting this answer")
                  ], -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "input-label" }, [
                      _createTextVNode("Explain your rejection "),
                      _createElementVNode("span", { class: "input-label-optional" }, "(optional)")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.questionAcceptRejectEdit.rejectReason) = $event)),
                      class: "input",
                      placeholder: "Enter your rejection reason",
                      type: "text"
                    }, null, 512), [
                      [_vModelText, _ctx.questionAcceptRejectEdit.rejectReason]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_base_button, {
                      variant: "outlined",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.questionAcceptRejectEdit.state = null))
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("Cancel", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_base_button, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = true))
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("Confirm Rejection", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_new_confirm_modal, {
              "is-visible": _ctx.questionAcceptRejectEdit.isPopConfirmOpened && _ctx.questionAcceptRejectEdit.state === 'reject',
              title: "Confirm Rejection to Answer",
              "accept-caption": 'Yes, reject it',
              "reject-caption": 'No, go back',
              onOnCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = false)),
              onOnConfirm: _cache[9] || (_cache[9] = () => {
          // $emit('setQuestionResponseState',question.id, 'rejected');
          const cb = () => {
            _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
            _ctx.questionAcceptRejectEdit.state = null;
          }
          _ctx.$emit('handleReviewQuestion', _ctx.question.id, _ctx.questionAcceptRejectEdit, cb);

        //   @todo show feedback message
        })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to reject \"" + _toDisplayString(_ctx.question.text) + "\"? ", 1)
              ]),
              _: 1
            }, 8, ["is-visible"]),
            _createVNode(_component_new_confirm_modal, {
              "is-visible": _ctx.questionAcceptRejectEdit.isPopConfirmOpened && _ctx.questionAcceptRejectEdit.state === 'accept',
              title: "Confirm and Accept",
              onOnCancel: _cache[10] || (_cache[10] = () => {
          _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
          _ctx.questionAcceptRejectEdit.state = null;
        }),
              onOnConfirm: _cache[11] || (_cache[11] = () => {
          const cb = () => {
            _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
            _ctx.questionAcceptRejectEdit.state = null;
          }
          _ctx.$emit('handleReviewQuestion', _ctx.question.id, _ctx.questionAcceptRejectEdit, cb);

        })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to accept \"" + _toDisplayString(_ctx.question.text) + "\"? ", 1)
              ]),
              _: 1
            }, 8, ["is-visible"]),
            _createVNode(_component_new_confirm_modal, {
              "is-visible": _ctx.questionAcceptRejectEdit.isPopConfirmOpened && _ctx.questionAcceptRejectEdit.state === 'edit',
              "accept-caption": 'Yes, save it',
              "reject-caption": 'No, go back',
              title: "Save Edit",
              onOnCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = false)),
              onOnConfirm: _cache[13] || (_cache[13] = () => {
          const cb = () => {
            _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
            _ctx.questionAcceptRejectEdit.state = null;
          }
          _ctx.$emit('handleReviewQuestion', _ctx.question.id, _ctx.questionAcceptRejectEdit, cb);

        })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to accept \"" + _toDisplayString(_ctx.question.text) + "\"? ", 1)
              ]),
              _: 1
            }, 8, ["is-visible"])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}